import EmployeeEmptySearchResults from '@web/users/EmptyStates/EmployeeEmptySearchResults/EmployeeEmptySearchResults';

export default {
  ReactComponent: EmployeeEmptySearchResults,
  bindings: {
    employeesCount: '<',
    joinRequestsCount: '<',
    deactivatedCount: '<',
    activeTab: '<',
    search: '<',
    changeTab: '&',
  },
};
